import { render } from "./Programs.vue?vue&type=template&id=09fb44ca&scoped=true&ts=true"
import script from "./Programs.vue?vue&type=script&lang=ts"
export * from "./Programs.vue?vue&type=script&lang=ts"

import "./Programs.vue?vue&type=style&index=0&id=09fb44ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fb44ca"]])

export default __exports__